// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Scalar from "../../core/Scalar.res.js";
import * as Client from "@apollo/client";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query variantsByCku($cku: CKU!, $filterBy: InputVariantsByCkuQueryFilter)  {\nvariantsByCku(cku: $cku, first: 50, filterBy: $filterBy)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nactive  \nformattedStatus  \narchivedAt  \nname  \nupdatedAt  \nformattedName  \ncapacityValue  \ncapacityUnit  \ncapacityPrecision  \nbulk  \nyear  \nalcoholVolume  \nean13  \nstockKeepingUnit  \npriceLookUpCode  \ninternalCode  \ntastingNote  \ninternalNote  \nmaxStockThreshold  \nminStockThreshold  \nstockOrderTriggerThreshold  \nshop  {\n__typename  \nid  \nname  \n}\n\nstock  {\n__typename  \nformattedShopsNames  \nrawQuantity  \nformattedQuantity  \nstate  \n}\n\nsupplier  {\n__typename  \nid  \ncompanyName  \n}\n\nformattedCategory  \nproduct  {\n__typename  \nid  \nname  \nformattedDescription  \nformattedOrigin  \ntax  {\n__typename  \nvalue  \n}\n\n}\n\npurchasedPrice  \nformattedPurchasedPrice  \nvariantPrices(first: 50)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \narchivedAt  \nvalueIncludingTax  \nvalueExcludingTax  \ntoQuantity  \nfromQuantity  \nprice  {\n__typename  \nid  \nname  \nenableByDefault  \ntaxIncluded  \narchivedAt  \n}\n\n}\n\n}\n\npageInfo  {\n__typename  \nhasNextPage  \n}\n\n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.variantsByCku;
  let value$2 = value$1.edges;
  return {
    variantsByCku: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.active;
        let value$3 = value$1.formattedStatus;
        let tmp;
        switch (value$3) {
          case "ACTIVE" :
            tmp = "ACTIVE";
            break;
          case "ARCHIVED" :
            tmp = "ARCHIVED";
            break;
          case "INACTIVE" :
            tmp = "INACTIVE";
            break;
          case "VARIABLE" :
            tmp = "VARIABLE";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        let value$4 = value$1.archivedAt;
        let value$5 = value$1.capacityValue;
        let value$6 = value$1.capacityUnit;
        let value$7 = value$1.capacityPrecision;
        let value$8 = value$1.bulk;
        let value$9 = value$1.year;
        let value$10 = value$1.alcoholVolume;
        let value$11 = value$1.ean13;
        let value$12 = value$1.stockKeepingUnit;
        let value$13 = value$1.priceLookUpCode;
        let value$14 = value$1.internalCode;
        let value$15 = value$1.tastingNote;
        let value$16 = value$1.internalNote;
        let value$17 = value$1.maxStockThreshold;
        let value$18 = value$1.minStockThreshold;
        let value$19 = value$1.stockOrderTriggerThreshold;
        let value$20 = value$1.shop;
        let value$21 = value$1.stock;
        let value$22 = value$21.formattedShopsNames;
        let value$23 = value$21.rawQuantity;
        let value$24 = value$21.formattedQuantity;
        let value$25 = value$21.state;
        let tmp$1;
        if (value$25 == null) {
          tmp$1 = undefined;
        } else {
          let tmp$2;
          switch (value$25) {
            case "ALERT" :
              tmp$2 = "ALERT";
              break;
            case "DANGER" :
              tmp$2 = "DANGER";
              break;
            case "OK" :
              tmp$2 = "OK";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$1 = tmp$2;
        }
        let value$26 = value$1.supplier;
        let value$27 = value$1.formattedCategory;
        let value$28 = value$1.product;
        let value$29 = value$28.formattedDescription;
        let value$30 = value$28.tax;
        let value$31 = value$1.purchasedPrice;
        let value$32 = value$1.formattedPurchasedPrice;
        let value$33 = value$1.variantPrices;
        let value$34 = value$33.edges;
        let value$35 = value$33.pageInfo;
        let value$36 = value$35.hasNextPage;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            active: !(value$2 == null) ? value$2 : undefined,
            formattedStatus: tmp,
            archivedAt: !(value$4 == null) ? Scalar.Datetime.parse(value$4) : undefined,
            name: value$1.name,
            updatedAt: Scalar.Datetime.parse(value$1.updatedAt),
            formattedName: value$1.formattedName,
            capacityValue: !(value$5 == null) ? value$5 : undefined,
            capacityUnit: !(value$6 == null) ? value$6 : undefined,
            capacityPrecision: !(value$7 == null) ? value$7 : undefined,
            bulk: !(value$8 == null) ? value$8 : undefined,
            year: !(value$9 == null) ? value$9 : undefined,
            alcoholVolume: !(value$10 == null) ? value$10 : undefined,
            ean13: !(value$11 == null) ? value$11 : undefined,
            stockKeepingUnit: !(value$12 == null) ? value$12 : undefined,
            priceLookUpCode: !(value$13 == null) ? value$13 : undefined,
            internalCode: !(value$14 == null) ? value$14 : undefined,
            tastingNote: !(value$15 == null) ? Scalar.Text.parse(value$15) : undefined,
            internalNote: !(value$16 == null) ? Scalar.Text.parse(value$16) : undefined,
            maxStockThreshold: !(value$17 == null) ? value$17 : undefined,
            minStockThreshold: !(value$18 == null) ? value$18 : undefined,
            stockOrderTriggerThreshold: !(value$19 == null) ? value$19 : undefined,
            shop: {
              __typename: value$20.__typename,
              id: value$20.id,
              name: value$20.name
            },
            stock: {
              __typename: value$21.__typename,
              formattedShopsNames: !(value$22 == null) ? value$22 : undefined,
              rawQuantity: !(value$23 == null) ? value$23 : undefined,
              formattedQuantity: !(value$24 == null) ? value$24 : undefined,
              state: tmp$1
            },
            supplier: !(value$26 == null) ? ({
                __typename: value$26.__typename,
                id: value$26.id,
                companyName: value$26.companyName
              }) : undefined,
            formattedCategory: !(value$27 == null) ? value$27 : undefined,
            product: {
              __typename: value$28.__typename,
              id: value$28.id,
              name: value$28.name,
              formattedDescription: !(value$29 == null) ? value$29 : undefined,
              formattedOrigin: value$28.formattedOrigin,
              tax: {
                __typename: value$30.__typename,
                value: value$30.value
              }
            },
            purchasedPrice: !(value$31 == null) ? value$31 : undefined,
            formattedPurchasedPrice: !(value$32 == null) ? value$32 : undefined,
            variantPrices: {
              __typename: value$33.__typename,
              edges: value$34.map(value => {
                let value$1 = value.node;
                let value$2 = value$1.archivedAt;
                let value$3 = value$1.toQuantity;
                let value$4 = value$1.fromQuantity;
                let value$5 = value$1.price;
                let tmp;
                if (value$5 == null) {
                  tmp = undefined;
                } else {
                  let value$6 = value$5.archivedAt;
                  tmp = {
                    __typename: value$5.__typename,
                    id: value$5.id,
                    name: value$5.name,
                    enableByDefault: value$5.enableByDefault,
                    taxIncluded: value$5.taxIncluded,
                    archivedAt: !(value$6 == null) ? Scalar.Datetime.parse(value$6) : undefined
                  };
                }
                return {
                  __typename: value.__typename,
                  node: {
                    __typename: value$1.__typename,
                    id: value$1.id,
                    archivedAt: !(value$2 == null) ? Scalar.Datetime.parse(value$2) : undefined,
                    valueIncludingTax: value$1.valueIncludingTax,
                    valueExcludingTax: value$1.valueExcludingTax,
                    toQuantity: !(value$3 == null) ? value$3 : undefined,
                    fromQuantity: !(value$4 == null) ? value$4 : undefined,
                    price: tmp
                  }
                };
              }),
              pageInfo: {
                __typename: value$35.__typename,
                hasNextPage: !(value$36 == null) ? value$36 : undefined
              }
            }
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.variantsByCku;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.variantPrices;
    let value$3 = value$2.pageInfo;
    let value$4 = value$3.hasNextPage;
    let hasNextPage = value$4 !== undefined ? value$4 : null;
    let value$5 = value$3.__typename;
    let pageInfo = {
      __typename: value$5,
      hasNextPage: hasNextPage
    };
    let value$6 = value$2.edges;
    let edges = value$6.map(value => {
      let value$1 = value.node;
      let value$2 = value$1.price;
      let price;
      if (value$2 !== undefined) {
        let value$3 = value$2.archivedAt;
        let archivedAt = value$3 !== undefined ? Scalar.Datetime.serialize(value$3) : null;
        let value$4 = value$2.taxIncluded;
        let value$5 = value$2.enableByDefault;
        let value$6 = value$2.name;
        let value$7 = value$2.id;
        let value$8 = value$2.__typename;
        price = {
          __typename: value$8,
          id: value$7,
          name: value$6,
          enableByDefault: value$5,
          taxIncluded: value$4,
          archivedAt: archivedAt
        };
      } else {
        price = null;
      }
      let value$9 = value$1.fromQuantity;
      let fromQuantity = value$9 !== undefined ? value$9 : null;
      let value$10 = value$1.toQuantity;
      let toQuantity = value$10 !== undefined ? value$10 : null;
      let value$11 = value$1.valueExcludingTax;
      let value$12 = value$1.valueIncludingTax;
      let value$13 = value$1.archivedAt;
      let archivedAt$1 = value$13 !== undefined ? Scalar.Datetime.serialize(value$13) : null;
      let value$14 = value$1.id;
      let value$15 = value$1.__typename;
      let node = {
        __typename: value$15,
        id: value$14,
        archivedAt: archivedAt$1,
        valueIncludingTax: value$12,
        valueExcludingTax: value$11,
        toQuantity: toQuantity,
        fromQuantity: fromQuantity,
        price: price
      };
      let value$16 = value.__typename;
      return {
        __typename: value$16,
        node: node
      };
    });
    let value$7 = value$2.__typename;
    let variantPrices = {
      __typename: value$7,
      edges: edges,
      pageInfo: pageInfo
    };
    let value$8 = value$1.formattedPurchasedPrice;
    let formattedPurchasedPrice = value$8 !== undefined ? value$8 : null;
    let value$9 = value$1.purchasedPrice;
    let purchasedPrice = value$9 !== undefined ? value$9 : null;
    let value$10 = value$1.product;
    let value$11 = value$10.tax;
    let value$12 = value$11.value;
    let value$13 = value$11.__typename;
    let tax = {
      __typename: value$13,
      value: value$12
    };
    let value$14 = value$10.formattedOrigin;
    let value$15 = value$10.formattedDescription;
    let formattedDescription = value$15 !== undefined ? value$15 : null;
    let value$16 = value$10.name;
    let value$17 = value$10.id;
    let value$18 = value$10.__typename;
    let product = {
      __typename: value$18,
      id: value$17,
      name: value$16,
      formattedDescription: formattedDescription,
      formattedOrigin: value$14,
      tax: tax
    };
    let value$19 = value$1.formattedCategory;
    let formattedCategory = value$19 !== undefined ? value$19 : null;
    let value$20 = value$1.supplier;
    let supplier;
    if (value$20 !== undefined) {
      let value$21 = value$20.companyName;
      let value$22 = value$20.id;
      let value$23 = value$20.__typename;
      supplier = {
        __typename: value$23,
        id: value$22,
        companyName: value$21
      };
    } else {
      supplier = null;
    }
    let value$24 = value$1.stock;
    let value$25 = value$24.state;
    let state = value$25 !== undefined ? (
        value$25 === "OK" ? "OK" : (
            value$25 === "ALERT" ? "ALERT" : "DANGER"
          )
      ) : null;
    let value$26 = value$24.formattedQuantity;
    let formattedQuantity = value$26 !== undefined ? value$26 : null;
    let value$27 = value$24.rawQuantity;
    let rawQuantity = value$27 !== undefined ? value$27 : null;
    let value$28 = value$24.formattedShopsNames;
    let formattedShopsNames = value$28 !== undefined ? value$28 : null;
    let value$29 = value$24.__typename;
    let stock = {
      __typename: value$29,
      formattedShopsNames: formattedShopsNames,
      rawQuantity: rawQuantity,
      formattedQuantity: formattedQuantity,
      state: state
    };
    let value$30 = value$1.shop;
    let value$31 = value$30.name;
    let value$32 = value$30.id;
    let value$33 = value$30.__typename;
    let shop = {
      __typename: value$33,
      id: value$32,
      name: value$31
    };
    let value$34 = value$1.stockOrderTriggerThreshold;
    let stockOrderTriggerThreshold = value$34 !== undefined ? value$34 : null;
    let value$35 = value$1.minStockThreshold;
    let minStockThreshold = value$35 !== undefined ? value$35 : null;
    let value$36 = value$1.maxStockThreshold;
    let maxStockThreshold = value$36 !== undefined ? value$36 : null;
    let value$37 = value$1.internalNote;
    let internalNote = value$37 !== undefined ? Scalar.Text.serialize(value$37) : null;
    let value$38 = value$1.tastingNote;
    let tastingNote = value$38 !== undefined ? Scalar.Text.serialize(value$38) : null;
    let value$39 = value$1.internalCode;
    let internalCode = value$39 !== undefined ? value$39 : null;
    let value$40 = value$1.priceLookUpCode;
    let priceLookUpCode = value$40 !== undefined ? value$40 : null;
    let value$41 = value$1.stockKeepingUnit;
    let stockKeepingUnit = value$41 !== undefined ? value$41 : null;
    let value$42 = value$1.ean13;
    let ean13 = value$42 !== undefined ? value$42 : null;
    let value$43 = value$1.alcoholVolume;
    let alcoholVolume = value$43 !== undefined ? value$43 : null;
    let value$44 = value$1.year;
    let year = value$44 !== undefined ? value$44 : null;
    let value$45 = value$1.bulk;
    let bulk = value$45 !== undefined ? value$45 : null;
    let value$46 = value$1.capacityPrecision;
    let capacityPrecision = value$46 !== undefined ? value$46 : null;
    let value$47 = value$1.capacityUnit;
    let capacityUnit = value$47 !== undefined ? value$47 : null;
    let value$48 = value$1.capacityValue;
    let capacityValue = value$48 !== undefined ? value$48 : null;
    let value$49 = value$1.formattedName;
    let value$50 = value$1.updatedAt;
    let value$51 = Scalar.Datetime.serialize(value$50);
    let value$52 = value$1.name;
    let value$53 = value$1.archivedAt;
    let archivedAt = value$53 !== undefined ? Scalar.Datetime.serialize(value$53) : null;
    let value$54 = value$1.formattedStatus;
    let formattedStatus = value$54 === "INACTIVE" ? "INACTIVE" : (
        value$54 === "ARCHIVED" ? "ARCHIVED" : (
            value$54 === "ACTIVE" ? "ACTIVE" : "VARIABLE"
          )
      );
    let value$55 = value$1.active;
    let active = value$55 !== undefined ? value$55 : null;
    let value$56 = value$1.id;
    let value$57 = value$1.__typename;
    let node = {
      __typename: value$57,
      id: value$56,
      active: active,
      formattedStatus: formattedStatus,
      archivedAt: archivedAt,
      name: value$52,
      updatedAt: value$51,
      formattedName: value$49,
      capacityValue: capacityValue,
      capacityUnit: capacityUnit,
      capacityPrecision: capacityPrecision,
      bulk: bulk,
      year: year,
      alcoholVolume: alcoholVolume,
      ean13: ean13,
      stockKeepingUnit: stockKeepingUnit,
      priceLookUpCode: priceLookUpCode,
      internalCode: internalCode,
      tastingNote: tastingNote,
      internalNote: internalNote,
      maxStockThreshold: maxStockThreshold,
      minStockThreshold: minStockThreshold,
      stockOrderTriggerThreshold: stockOrderTriggerThreshold,
      shop: shop,
      stock: stock,
      supplier: supplier,
      formattedCategory: formattedCategory,
      product: product,
      purchasedPrice: purchasedPrice,
      formattedPurchasedPrice: formattedPurchasedPrice,
      variantPrices: variantPrices
    };
    let value$58 = value.__typename;
    return {
      __typename: value$58,
      node: node
    };
  });
  let value$3 = value$1.__typename;
  let variantsByCku = {
    __typename: value$3,
    edges: edges
  };
  return {
    variantsByCku: variantsByCku
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectInputVariantsByCkuQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.active;
  let a$2 = inp.archived;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter(a) : undefined,
    active: a$1 !== undefined ? ({
        _equals: a$1._equals
      }) : undefined,
    archived: a$2 !== undefined ? (
        a$2 === "ONLY" ? "ONLY" : (
            a$2 === "INCLUDED" ? "INCLUDED" : "EXCLUDED"
          )
      ) : undefined
  };
}

function serializeInputObjectBooleanEqualsFilter(inp) {
  return {
    _equals: inp._equals
  };
}

function serializeVariables(inp) {
  let a = inp.filterBy;
  return {
    cku: inp.cku,
    filterBy: a !== undefined ? serializeInputObjectInputVariantsByCkuQueryFilter(a) : undefined
  };
}

function makeVariables(cku, filterBy, param) {
  return {
    cku: cku,
    filterBy: filterBy
  };
}

function makeInputObjectInputVariantsByCkuQueryFilter(shopIds, active, archived, param) {
  return {
    shopIds: shopIds,
    active: active,
    archived: archived
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeInputObjectBooleanEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

let VariantQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputVariantsByCkuQueryFilter: serializeInputObjectInputVariantsByCkuQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectBooleanEqualsFilter: serializeInputObjectBooleanEqualsFilter,
  makeVariables: makeVariables,
  makeInputObjectInputVariantsByCkuQueryFilter: makeInputObjectInputVariantsByCkuQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectBooleanEqualsFilter: makeInputObjectBooleanEqualsFilter
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let VariantQuery_refetchQueryDescription = include.refetchQueryDescription;

let VariantQuery_use = include.use;

let VariantQuery_useLazy = include.useLazy;

let VariantQuery_useLazyWithVariables = include.useLazyWithVariables;

let VariantQuery = {
  VariantQuery_inner: VariantQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputVariantsByCkuQueryFilter: serializeInputObjectInputVariantsByCkuQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectBooleanEqualsFilter: serializeInputObjectBooleanEqualsFilter,
  makeVariables: makeVariables,
  makeInputObjectInputVariantsByCkuQueryFilter: makeInputObjectInputVariantsByCkuQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectBooleanEqualsFilter: makeInputObjectBooleanEqualsFilter,
  refetchQueryDescription: VariantQuery_refetchQueryDescription,
  use: VariantQuery_use,
  useLazy: VariantQuery_useLazy,
  useLazyWithVariables: VariantQuery_useLazyWithVariables
};

let Raw$1 = {};

let query$1 = Client.gql(["query variantsByCku_shops($cku: CKU!)  {\nvariantsByCku(cku: $cku, first: 50, filterBy: {archived: INCLUDED})  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nshop  {\n__typename  \nid  \n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse$1(value) {
  let value$1 = value.variantsByCku;
  let value$2 = value$1.edges;
  return {
    variantsByCku: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.shop;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            shop: {
              __typename: value$2.__typename,
              id: value$2.id
            }
          }
        };
      })
    }
  };
}

function serialize$1(value) {
  let value$1 = value.variantsByCku;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.shop;
    let value$3 = value$2.id;
    let value$4 = value$2.__typename;
    let shop = {
      __typename: value$4,
      id: value$3
    };
    let value$5 = value$1.id;
    let value$6 = value$1.__typename;
    let node = {
      __typename: value$6,
      id: value$5,
      shop: shop
    };
    let value$7 = value.__typename;
    return {
      __typename: value$7,
      node: node
    };
  });
  let value$3 = value$1.__typename;
  let variantsByCku = {
    __typename: value$3,
    edges: edges
  };
  return {
    variantsByCku: variantsByCku
  };
}

function serializeVariables$1(inp) {
  return {
    cku: inp.cku
  };
}

function makeVariables$1(cku, param) {
  return {
    cku: cku
  };
}

let VariantShopsQuery_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1
};

let include$1 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});

let VariantShopsQuery_refetchQueryDescription = include$1.refetchQueryDescription;

let VariantShopsQuery_use = include$1.use;

let VariantShopsQuery_useLazy = include$1.useLazy;

let VariantShopsQuery_useLazyWithVariables = include$1.useLazyWithVariables;

let VariantShopsQuery = {
  VariantShopsQuery_inner: VariantShopsQuery_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  refetchQueryDescription: VariantShopsQuery_refetchQueryDescription,
  use: VariantShopsQuery_use,
  useLazy: VariantShopsQuery_useLazy,
  useLazyWithVariables: VariantShopsQuery_useLazyWithVariables
};

let Raw$2 = {};

let query$2 = Client.gql(["query variant_cku($id: ID!)  {\nvariant(id: $id)  {\n__typename  \ncku  \n}\n\n}\n"]);

function parse$2(value) {
  let value$1 = value.variant;
  return {
    variant: !(value$1 == null) ? ({
        __typename: value$1.__typename,
        cku: Scalar.CKU.parse(value$1.cku)
      }) : undefined
  };
}

function serialize$2(value) {
  let value$1 = value.variant;
  let variant;
  if (value$1 !== undefined) {
    let value$2 = value$1.cku;
    let value$3 = Scalar.CKU.serialize(value$2);
    let value$4 = value$1.__typename;
    variant = {
      __typename: value$4,
      cku: value$3
    };
  } else {
    variant = null;
  }
  return {
    variant: variant
  };
}

function serializeVariables$2(inp) {
  return {
    id: inp.id
  };
}

function makeVariables$2(id, param) {
  return {
    id: id
  };
}

let VariantCkuQuery_inner = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2
};

let include$2 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$2,
  Raw: Raw$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2
});

let VariantCkuQuery_refetchQueryDescription = include$2.refetchQueryDescription;

let VariantCkuQuery_use = include$2.use;

let VariantCkuQuery_useLazy = include$2.useLazy;

let VariantCkuQuery_useLazyWithVariables = include$2.useLazyWithVariables;

let VariantCkuQuery = {
  VariantCkuQuery_inner: VariantCkuQuery_inner,
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2,
  refetchQueryDescription: VariantCkuQuery_refetchQueryDescription,
  use: VariantCkuQuery_use,
  useLazy: VariantCkuQuery_useLazy,
  useLazyWithVariables: VariantCkuQuery_useLazyWithVariables
};

let Raw$3 = {};

let query$3 = Client.gql(["query prices  {\nprices(first: 50)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nname  \ntaxIncluded  \nshop  {\n__typename  \nid  \n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse$3(value) {
  let value$1 = value.prices;
  let value$2 = value$1.edges;
  return {
    prices: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.shop;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            name: value$1.name,
            taxIncluded: value$1.taxIncluded,
            shop: {
              __typename: value$2.__typename,
              id: value$2.id
            }
          }
        };
      })
    }
  };
}

function serialize$3(value) {
  let value$1 = value.prices;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.shop;
    let value$3 = value$2.id;
    let value$4 = value$2.__typename;
    let shop = {
      __typename: value$4,
      id: value$3
    };
    let value$5 = value$1.taxIncluded;
    let value$6 = value$1.name;
    let value$7 = value$1.id;
    let value$8 = value$1.__typename;
    let node = {
      __typename: value$8,
      id: value$7,
      name: value$6,
      taxIncluded: value$5,
      shop: shop
    };
    let value$9 = value.__typename;
    return {
      __typename: value$9,
      node: node
    };
  });
  let value$3 = value$1.__typename;
  let prices = {
    __typename: value$3,
    edges: edges
  };
  return {
    prices: prices
  };
}

function serializeVariables$3() {
  
}

function makeVariables$3() {
  
}

function makeDefaultVariables() {
  
}

let PricesQuery_inner = {
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3,
  makeDefaultVariables: makeDefaultVariables
};

let include$3 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$3,
  Raw: Raw$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3
});

let PricesQuery_refetchQueryDescription = include$3.refetchQueryDescription;

let PricesQuery_use = include$3.use;

let PricesQuery_useLazy = include$3.useLazy;

let PricesQuery_useLazyWithVariables = include$3.useLazyWithVariables;

let PricesQuery = {
  PricesQuery_inner: PricesQuery_inner,
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: PricesQuery_refetchQueryDescription,
  use: PricesQuery_use,
  useLazy: PricesQuery_useLazy,
  useLazyWithVariables: PricesQuery_useLazyWithVariables
};

export {
  VariantQuery,
  VariantShopsQuery,
  VariantCkuQuery,
  PricesQuery,
}
/* query Not a pure module */
